export const SFRTA_BridgeTestsAndInspectionReportSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
      },
      headerOnly: true,
      columns: [
        {
          title: "Bridge Locking (FRA 236.387) Annual",
          colSpan: 20,
          rowSpan: 1,
          className: "tbl-text-normal",
        },
      ],
    },
    {
      heights: {
        header1: "auto",
      },
      minDataRowsCount: 1,
      columns: [
        {
          title: "Circuit Nomenclature",
          colSpan: 12,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.bloc",
          dataClassName: "text-left pd-left-10px d-block",
          subAccessor: "desc",
          isArray: true,
          minDataRowsCount: 1,
        },
        {
          title: "Condition Left",
          colSpan: 8,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.bloc",
          subAccessor: "test",
          isArray: true,
          minDataRowsCount: 1,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/BridgeTestsAndInspectionReport/SFRTA_BridgeTestsAndInspectionReportSchema.js